import { Box, Container, Typography } from "@mui/material";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { agreementDoc } from "../../../utils/constants";

export function ContentRendererParagraph(block: any) {
  const { isForAgreementGeneration } = block ?? {};

  return (
    <Container maxWidth="lg" sx={{ my: isForAgreementGeneration ? undefined : 4 }}>
      <Box textAlign={block.textAlign}>
        <BlocksRenderer
          blocks={{
            paragraph: (p) => (
              <Typography
                variant="body1"
                {...p}
                sx={{
                  ...(isForAgreementGeneration && {
                    fontFamily: agreementDoc.fontFamily,
                    fontSize: agreementDoc.paragraph.fontSize,
                    lineHeight: agreementDoc.paragraph.lineHeight,
                    textAlign: agreementDoc.paragraph.textAlign,
                  }),
                }}
              />
            ),
            ...(isForAgreementGeneration && {
              heading: ({ children, level }) => {
                switch (level) {
                  case 1:
                    return (
                      <Typography variant="h1" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  case 2:
                    return (
                      <Typography variant="h2" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  case 3:
                    return (
                      <Typography variant="h3" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  case 4:
                    return (
                      <Typography variant="h4" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  case 5:
                    return (
                      <Typography variant="h5" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  case 6:
                    return (
                      <Typography variant="h6" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                  default:
                    return (
                      <Typography variant="h1" sx={{ fontFamily: agreementDoc.fontFamily }}>
                        {children}
                      </Typography>
                    );
                }
              },
            }),
          }}
          content={block.content}
        />
      </Box>
    </Container>
  );
}
